/* eslint-disable import/prefer-default-export */
import Vue from 'vue';
import { isNil } from 'lodash';
import store from '@/store';
import { faultAnalysisStoreAction } from '@/constants/fault-analysis';
import MsgUtil from '@/utils/message';

const vm = new Vue();
/**
 * 장애 분석 팝업을 연다.
 * @author Ju
 * @param  {Number}  seqNumber 이벤트 이력 seqNumber
 */
export function openFaultAnalysisPopup(seqNumber) {
  if (isNil(seqNumber)) {
    vm.$message(MsgUtil.getCustomResultMsgData('이벤트 정보가 없습니다.', false));
    return;
  }
  store.dispatch(faultAnalysisStoreAction.OPEN_POPUP, seqNumber);
}

/**
 * 장애 분석 팝업을 닫는다.
 * @author Ju
 */
export function closeFaultAnalysisPopup() {
  store.dispatch(faultAnalysisStoreAction.CLOSE_POPUP);
}

/**
 * 장애 분석 팝업이 열려져 있는 지 여부를 반환한다.
 * @author Ju
 * @return {Boolean} [description]
 */
export function isShowFaultAnalysisPopup() {
  return store.state.event.showFaultAnalysisPopup;
}

/**
 * 이벤트 SmartAnalyzer 팝업을 연다.
 * @author Ju
 * @param  {Array} seqNumbers 이벤트 이력 seqNumber 배열
 */
export function openEventSmartAnalyzerPopup(seqNumbers) {
  store.dispatch('openEventSmartAnalyzerPopup', seqNumbers);
}

/**
 * 이벤트 SmartAnalyzer 팝업을 닫는다.
 * @author Ju
 */
export function closeEventSmartAnalyzerPopup() {
  store.dispatch('closeEventSmartAnalyzerPopup');
}

/**
 * 이벤트 SmartAnalyzer 팝업이 열려져 있는 지 여부를 반환한다.
 * @author Ju
 * @return {Boolean} [description]
 */
export function isShowEventSmartAnalyzerPopup() {
  return store.state.smartAnalyzer.showEventPopup;
}



// WEBPACK FOOTER //
// ./src/utils/event.js